// Headline school figures, edited from Settings → School in Numbers and shown on
// the homepage hero, the "School in Numbers" section and the About page.
// These defaults match the schoolStats defaults in Backend/models/SiteSettings.js
// and are shown until settings load (or if the request fails).
export const DEFAULT_SCHOOL_STATS = {
  students: 1312,
  teachers: 43,
  nonTeachingStaff: 20,
  classrooms: 30,
  years: 25,
};

export const withStatDefaults = (stats) => ({ ...DEFAULT_SCHOOL_STATS, ...(stats || {}) });

// Derived from students ÷ teachers so it never disagrees with the two figures above.
export const teacherStudentRatio = ({ students, teachers }) =>
  teachers > 0 ? `1 : ${Math.round(students / teachers)}` : "—";
